<template>
    <div>
        <PromoBanner
            v-if="!hasSubscription"
            :is-paid="true"
            feature="analytics"
        >
            <template #title>{{
                $t("event_types.analytics_detail.banner.title")
            }}</template>
            <template #description>{{
                $t("event_types.analytics_detail.banner.description")
            }}</template>
            <template #icon>
                <LineChart :size="20" class="text-[#E92F34]" />
            </template>
        </PromoBanner>
        <div v-else>
            <h2 class="text-lg font-medium tracking-[-0.02em]">
                {{ $t("event_types.event_detail.analytics") }}
            </h2>

            <p class="mb-8 text-sm tracking-[-0.01em] text-iron-500">
                {{ $t("event_types.event_detail.analytics_description") }}
            </p>
            <div class="mt-8">
                <h3 class="font-medium">Google Analytics</h3>
                <div class="mt-2 grid items-center gap-1">
                    <Label for="measerumentId">Measerument Id</Label>
                    <Input
                        id="measerumentId"
                        v-model="analytics.measurementId"
                    />
                </div>
            </div>
            <div class="mt-5">
                <h3 class="font-medium">Meta (Facebook) Pixel</h3>
                <div class="mt-2 grid items-center gap-1">
                    <Label for="fbPixel">Pixel</Label>
                    <Input id="fbPixel" v-model="analytics.facebookPixel" />
                </div>
            </div>

            <div class="mt-5">
                <h3 class="font-medium">Umami</h3>
                <div class="mt-2 grid items-center gap-1">
                    <Label for="umamiSrc">Src</Label>
                    <Input id="umamiSrc" v-model="analytics.umamiSrc" />
                </div>
                <div class="mt-2 grid items-center gap-1">
                    <Label for="umamiDataWebsiteId">Data Website Id</Label>
                    <Input
                        id="umamiDataWebsiteId"
                        v-model="analytics.umamiDataWebsiteId"
                    />
                </div>
            </div>
        </div>

        <Transition>
            <div v-if="!isSaved" class="flex justify-end">
                <Button class="mt-5" :disabled="isSaved" @click="save">
                    {{ $t("save") }}</Button
                >
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { EventType } from "../types/EventType";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { reactive, ref, watch } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import PromoBanner from "../../Atomic/PromoBanner.vue";
import { LineChart } from "lucide-vue-next";
import { useHasSubscription } from "@/composables/useHasSubscription";
import { Link } from "@inertiajs/vue3";
const { hasSubscription } = useHasSubscription();

const props = defineProps<{
    eventType: EventType;
}>();

const analytics = reactive({
    measurementId: props.eventType.analytics?.measurementId,
    facebookPixel: props.eventType.analytics?.facebookPixel,
    umamiSrc: props.eventType.analytics?.umamiSrc,
    umamiDataWebsiteId: props.eventType.analytics?.umamiDataWebsiteId,
});

watch(analytics, () => {
    isSaved.value = false;
});

const isSaved = ref(true);

async function save() {
    router.put(
        route("app.event-types.analytics.update", {
            eventType: props.eventType.id,
        }),
        analytics,
        {
            onSuccess: () => {
                isSaved.value = true;
            },
        },
    );
}
</script>
